/**
 * Stable per-browser-tab id. Every kiosk_session write is stamped with this
 * (see the PocketBase adapter) so a listening session can tell its own realtime
 * echoes apart from genuine remote updates and avoid clobbering locally typed-in
 * form fields. Shared between the adapter (which stamps writes) and the kiosk UI
 * (which ignores echoes carrying this origin).
 */
export const KIOSK_CLIENT_ORIGIN =
  typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : `kiosk-${Math.random().toString(36).slice(2)}-${Date.now()}`
